// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5407da2","869":"5c73530c"}[chunkId] + ".chunk.js";
};